import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'billingGroupParents',
  inputShow: gql`
    query billingGroupParents($input: BillingGroupParentQueryInput) {
      billingGroupParents(input: $input) {
        id
        name
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    label: 'Billing Group Parents',
    group: 'Facilities',
    order: 4,
  },
};
